/**
 * Per-race display bits for the shell (M8): the loading card's race line.
 * Facts come from the catalog race / manifest race — nothing is invented here. The display table
 * pins the Monza card text ("UNDERCUT / ITALIAN GRAND PRIX 2024 · MONZA", English since v0.7.0);
 * everything else falls back to `<NAME> <SEASON>` (+ ` · <CIRCUIT>` when the catalog's circuit id
 * adds anything).
 */

export interface RaceDisplayInfo {
  id: string;
  name?: string | undefined;
  season?: number | undefined;
  /** catalog `circuit` / manifest `circuit_id` (the machine id, e.g. 'monza') — not the long name */
  circuit?: string | undefined;
}

/** Card text per race id (the 2024 Monza legacy bundle has no catalog entry to derive it from). */
const RACE_DISPLAY: Readonly<Record<string, string>> = {
  '2024-monza': "ITALIAN GRAND PRIX 2024 · MONZA",
};

/** The loading card's race line: 'ITALIAN GRAND PRIX 2024 · MONZA' style. */
export function raceDisplayLine(race: RaceDisplayInfo): string {
  const pinned = RACE_DISPLAY[race.id];
  if (pinned) return pinned;
  let line = `${(race.name ?? race.id).toUpperCase()}${race.season !== undefined ? ` ${String(race.season)}` : ''}`;
  const circuit = race.circuit?.toUpperCase() ?? '';
  if (circuit !== '' && !line.includes(circuit)) line += ` · ${circuit}`;
  return line;
}
